import { Component, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { User } from 'src/app/classes/user';
import { UserService } from 'src/app/services/user.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
	selector: 'app-manage-2fa',
	templateUrl: './manage-2fa.component.html',
	styles: [ `mat-radio-button{ margin:.5em 1.5em }` ]
})
export class Manage2FAComponent implements OnInit {


	bChangeInProgress = false;

	@Input() user = new User();

	typeInProgress: 'authenticator' | 'email' | 'disabled' = "authenticator";
	savedType: 'authenticator' | 'email' | 'disabled' = "authenticator";
	QRSecret = "";

	bValidationNeeded = false;
	totpCode = "";

	bRequestForEmailFailed = false;

	statusStrings = { authenticator: "Aktiviert, per App", email: "Aktiviert, per Email", disabled: "Deaktiviert" };

	private get userId(): string {
		return this.user?.ebeId || this.authenticationService.getCurrentUser().ebeId;
	}

	private get twoFactorToken(): string {
		return this.user?.zweiFaktorToken || this.localStorage.getItem('twoFactorToken') || '';
	}
	

	constructor(
		private userService: UserService,
		private authenticationService: AuthenticationService,
		private matSnackBar: MatSnackBar,
		@Inject('LOCALSTORAGE') private localStorage: Storage,
	) {}


	ngOnInit() {

		console.log(this.authenticationService.getCurrentUser(), 'current user');
		this.deduceType();
		this.typeInProgress = this.savedType;
	}

	private updateTwoFactorStatus(authenticatorActive: boolean, emailActive: boolean, zweiFaktorToken: string) {
		return this.authenticationService.isConnected()
			? this.userService.set2FactorAuthSettingsUsermanagement(this.userId, authenticatorActive, emailActive, zweiFaktorToken)
			: this.userService.set2FactorAuthSettings(this.userId, authenticatorActive, emailActive, zweiFaktorToken);
	}


	deduceType() {
		if( this.user.zweiFaktorAktive && this.user.zweiFaktorEmailPruefung ) this.savedType = "email";
		else if( this.user.zweiFaktorAktive ) this.savedType = "authenticator";
		else this.savedType = "disabled";
	}


	disable2FA() {

		this.QRSecret = "";
		this.bRequestForEmailFailed = false;
		this.bValidationNeeded = false;
		this.typeInProgress = "disabled";
		console.log(this.userId);

		const isLoggedIn = this.authenticationService.isConnected();
		const twoFactorToken = this.twoFactorToken;
		if( !isLoggedIn && !twoFactorToken ) {
			this.matSnackBar.open('Fehler: 2FA-Token nicht gefunden', '', { duration: 5000 });
			return;
		}

		this.updateTwoFactorStatus( false, false, twoFactorToken || '' ).subscribe( u => {
			if( !u ) return;

			this.user.zweiFaktorAktive = u.zweiFaktorAktive;
			this.user.zweiFaktorPruefung = u.zweiFaktorPruefung;
			this.user.zweiFaktorEmailPruefung = u.zweiFaktorEmailPruefung;
			this.user.zweiFaktorToken = u.zweiFaktorToken || "";
			this.savedType = "disabled";

		});

	}

	enable2FAApp() {

		this.QRSecret = "";
		console.log(this.QRSecret, 'qr secret');
		this.bRequestForEmailFailed = false;
		this.bValidationNeeded = false;
		this.typeInProgress = "authenticator";

		console.log(this.userId, 'ebeID', this.user, 'user');

		// Abrufen des gespeicherten 2FA-Tokens aus dem localStorage
		const twoFactorToken = this.twoFactorToken;
		const isLoggedIn = this.authenticationService.isConnected();
		if (!isLoggedIn && !twoFactorToken) {
		  this.matSnackBar.open('Fehler: 2FA-Token nicht gefunden', '', { duration: 5000 });
		  return;
		}

		this.updateTwoFactorStatus( true, false, twoFactorToken || '' ).subscribe( u => {
			if( !u ) return;

			this.user.zweiFaktorAktive = u.zweiFaktorAktive;
			this.user.zweiFaktorPruefung = u.zweiFaktorPruefung;
			this.user.zweiFaktorEmailPruefung = u.zweiFaktorEmailPruefung;
			this.user.zweiFaktorToken = u.zweiFaktorToken || "";
			this.bValidationNeeded = true;

			// https://chart.googleapis.com/chart?chs=200x200&cht=qr&chl=200x200&chld=M|0&cht=qr&chl=otpauth://totp/ARGE Rück Mitgliederportal?secret=ST7NWDJKZBJFJLOJ
			const arr = u.zweiFaktorId.split( "secret=" );
			if( !arr.length || arr.length != 2 ) this.QRSecret = "error";
			else this.QRSecret = arr[1];

			localStorage.setItem('show2FALoginInfo', 'true');

		});

	}

	enable2FAEmail() {

		this.QRSecret = "";
		this.bRequestForEmailFailed = false;
		this.bValidationNeeded = false;
		this.typeInProgress = "email";

		console.log(this.userId, 'ebeID', this.user, 'user');

		const twoFactorToken = this.twoFactorToken;
		const isLoggedIn = this.authenticationService.isConnected();

		if (!isLoggedIn && !twoFactorToken) {
			this.matSnackBar.open('Fehler: 2FA-Token nicht gefunden', '', { duration: 5000 });
			return;
		}

		this.updateTwoFactorStatus( false, true, twoFactorToken || '' ).subscribe( u => {
			if( !u ) return;

			this.user.zweiFaktorAktive = u.zweiFaktorAktive;
			this.user.zweiFaktorPruefung = u.zweiFaktorPruefung;
			this.user.zweiFaktorEmailPruefung = u.zweiFaktorEmailPruefung;
			this.user.zweiFaktorToken = u.zweiFaktorToken || "";
			this.bValidationNeeded = true;

			console.log(this.user, 'user nach set2Factor Auth Settings');

			this.authenticationService.requestTotpEmail( {
				...this.authenticationService.getCurrentUser(),
				ebeId: this.userId
			} ).subscribe( b => {
				this.bRequestForEmailFailed = !b;
			} );

			localStorage.setItem('show2FALoginInfo', 'true');

		});

	}


	onTotpReady( obj: { totpCode: string, bAutoSend: boolean } ) {

		this.totpCode = obj.totpCode;
		if( obj.bAutoSend ) {
			this.validateF2A();
		}
	}

	validateF2A() {

		const isLoggedIn = this.authenticationService.isConnected();

		if( isLoggedIn ) {
			this.bChangeInProgress = true;
			this.userService.validateF2AUsermanagement( this.userId, this.totpCode ).subscribe( b => {

				this.bChangeInProgress = false;
				if( b ) {
					this.bValidationNeeded = false;
					this.totpCode = "";
					this.QRSecret = "";
					this.savedType = this.typeInProgress;
				}

			});
			return;
		}

		// nicht eingeloggt: Token erforderlich
		if( !this.twoFactorToken ) {
			this.matSnackBar.open('Fehler: 2FA-Token nicht gefunden', '', { duration: 5000 });
			return;
		}

		this.bChangeInProgress = true;
		this.userService.validateF2A( this.userId, this.twoFactorToken, this.totpCode ).subscribe( b => {

			this.bChangeInProgress = false;
			if( b ) {
				this.bValidationNeeded = false;
				this.totpCode = "";
				this.QRSecret = "";
				this.savedType = this.typeInProgress;
			}

		});

	}

	cancelValidation() {
		this.bValidationNeeded = false;
		this.totpCode = "";
		this.QRSecret = "";
		this.typeInProgress = "disabled";
		this.savedType = "disabled";
		this.disable2FA();
	}


}
